import api from './_api'
import Cookie from 'js-cookie'

export async function getUser(lang, state, ctx) {
    const accessToken = ctx?.req?.cookies?.['accessToken'] || Cookie.get('accessToken')
    const newState = state
    let user;

    if (accessToken) {
        user = await _getUser(lang, accessToken, ctx.res)
        newState.user = user
        newState.isLoggedIn = true
    } else {
        newState.isLoggedIn = false
        newState.user = {}
    }

    return { newState }
}

const _getUser = async (lang, accessToken, res) => {
    return await api
        .get('get-user', lang, {}, accessToken)
        .then((res) => {
            return res.user
        })
        .catch((err) => {
            if (process?.browser) {
                document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'
            } else {
                res.clearCookie('access_token')
            }
        })
}